import { createSlice } from '@reduxjs/toolkit';
import type { MachineOwnershipData } from '~/data/Asset';
import ProductDataAPI from '~/api/product-data-api';
import { updateAssetOwnershipData } from '~/ducks/asset-updates/actions';
import createCaughtAsyncThunk from '~/utils/create-action/create-caught-async-thunk';
import { initialState } from './data/ProductDataState';

export const saveMachineOwnershipData = createCaughtAsyncThunk<
  unknown,
  { assetId: AssetId; ownershipData: MachineOwnershipData }
>('saveProductData', async (args, thunkAPI) => {
  const response = await ProductDataAPI.editOwnershipData(
    args.assetId,
    args.ownershipData
  );

  thunkAPI.dispatch(
    updateAssetOwnershipData({
      assetId: args.assetId,
      ownershipData: args.ownershipData,
    })
  );

  return response;
});

const productDataSlice = createSlice({
  name: 'product-data',
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveMachineOwnershipData.pending, (state) => {
        state.isSaving = true;
        delete state.error;
      })
      .addCase(saveMachineOwnershipData.fulfilled, (state) => {
        state.isSaving = false;
      })
      .addCase(saveMachineOwnershipData.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload;
      });
  },
});

export const { resetState } = productDataSlice.actions;
export default productDataSlice.reducer;
